import { Currency } from 'enums/currency';

export const FIAT_CURRENCY_SYMBOLS: { [key in Currency]: string } = {
  [Currency.Pln]: 'zł',
  [Currency.Usd]: '$',
};
